<template>
    <v-toolbar
            color="primary"
            fixed
            dark
            app
    >
        <v-toolbar-title class="ml-0 pl-3">
            <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
        </v-toolbar-title>
        <v-autocomplete
                v-show="!airportAgency()"
                @change="goToPassengerProfile"
                :items="searchResults"
                :loading="loading"
                :search-input.sync="search"
                item-value="id"
                item-text="username"
                no-filter
                flat
                solo-inverted
                class="hidden-sm-and-down"
                label="Start typing to Search"
                prepend-inner-icon="search"
        >
            <template
                    slot="item"
                    slot-scope="data"
            >
                <v-list-tile-avatar>
                    <img :src="api.GET_IMAGE(data.item.profile_image)" :alt="data.item.id">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title
                            v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
                </v-list-tile-content>
            </template>
        </v-autocomplete>
        <v-spacer></v-spacer>
        <v-switch
                v-show="!airportAgency()"
                :disabled="true"
                v-model="online"
                :label="online ? 'On' : 'Off'"
                color="green"
                class="mt-3"
        />
        <v-btn v-show="!airportAgency()" @click="snoozeAI"
               :disabled="$store.state.ai_status.ai_stopped ==   '0'"
               flat>
            AI {{ai_dispatch_left}}
        </v-btn>
        <v-btn icon @click="handleFullScreen()">
            <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-menu v-show="!airportAgency()" offset-y origin="center center" class="elelvation-1" :nudge-bottom="14"
                transition="scale-transition">
            <v-btn icon flat slot="activator">
                <v-badge color="red" overlap>
                    <span slot="badge">{{$store.state.notifications.length}}</span>
                    <v-icon medium>notifications</v-icon>
                </v-badge>
            </v-btn>
            <notification-list
                    :notifications="$store.state.notifications.slice().splice(-5).reverse()"></notification-list>

        </v-menu>
        <v-btn icon @click="addNewProjectSchedule()">
            <v-icon>fa fa-plus</v-icon>
        </v-btn>
        <v-dialog v-model="projectScheduleDialog" max-width="500">
            <user-project-schedule></user-project-schedule>
        </v-dialog>
        <v-dialog v-model="follow_up_ticket" max-width="50%">
            <create-follow-up-ticket :key="follow_up_ticket" @saved="follow_up_ticket = false"/>
        </v-dialog>
        <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
            <v-btn icon large flat slot="activator">
                <v-avatar size="30px">
                    <img :src="api.GET_IMAGE(image)" alt="Michael Wang"/>
                </v-avatar>
            </v-btn>
            <v-list class="pa-0">
                <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null"
                             :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled"
                             :target="item.target" rel="noopener" :key="index">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
    </v-toolbar>

</template>
<script>
    import NotificationList from '@/components/NotificationList';
    import Util from '@/util';
    import moment from "moment";
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
    import CreateFollowUpTicket from "@/components/CreateFollowUpTicket";
    import UserProjectSchedule from "@/views/UserProjectSchedule";

    export default {
        name: 'app-toolbar',
        mixins: [hasIntervalsMixin],
        components: {
            UserProjectSchedule,
            NotificationList,
            CreateFollowUpTicket
        },
        watch: {
            search(val) {
                this.loading = true;
                const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val);
                this.axios.get(this.api.ACTIONS.PASSENGERS, {params})
                    .then(res => {
                        const {data} = res.data;
                        this.searchResults = data.map(item => ({
                            text: item.first_name + " " + item.last_name + " " + item.username + " " + item.whatsapp_number + " " + item.email,
                            ...item
                        }));
                    })
                    .catch(err => console.log(err))
                    .finally(() => this.loading = false);
            },
        },
        data() {
            return {
                search: null,
                searchResults: [],
                selectedPassenger: null,
                ai_dispatch_left: "00:00",
                loading: false,
                follow_up_ticket: false,
                items: [
                    {
                        icon: 'account_circle',
                        href: '#',
                        title: 'Profile',
                        click: (e) =>
                            this.$router.push({
                                name: "UserProfile",
                                params: {id: this.$store.state.user.id}
                            })
                    },
                    {
                        icon: 'settings',
                        href: '#user_settings',
                        title: 'Settings',
                        click: (e) => this.$router.push({
                            name: "UserSettings"
                        })
                    },
                    {
                        icon: 'report_problem',
                        href: '#',
                        title: 'Report Problem',
                        click: e =>
                            this.follow_up_ticket = true
                    },
                    {
                        icon: 'fullscreen_exit',
                        href: '#',
                        title: 'Logout',
                        click: (e) => {
                            this.axios.put(this.api.ACTIONS.LOGOUT)
                                .then(() => {
                                    window.getApp.$emit('APP_LOGOUT');
                                })
                                .catch(err => {
                                    window.getApp.$emit("SHOW_TOAST", "err (check console)");
                                    console.log(err);
                                    console.log(err.response);
                                    console.log(err.response.data);
                                }).finally(
                                () => {
                                    this.$store.commit("LOGOUT");
                                    this.$router.push({name: "Login"});
                                }
                            )

                        }
                    },

                ],
                projectScheduleDialog: false,
            }
        },
        computed: {
            image() {
                return this.$store.state.user.profile_image
            },
            online: {
                get() {
                    return this.$store.state.user.online;
                },
                set() {
                    // this.loading = true;
                    // this.axios.put('user/check')
                    //     .then(({data}) => this.$store.commit('SET_ONLINE', data.data))
                    //     .catch(err => window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red"))
                    //     .finally(() => this.loading = false)
                }
            }
        },
        methods: {
            snoozeAI() {
                this.loading = true;
                this.axios.put('snooze_ai')
                    .then(
                        () => window.getApp.$emit("SHOW_TOAST", "Snoozed")
                    )
                    .catch(
                        ({response: {data}}) => window.getApp.$emit("SHOW_TOAST", data.message, "red")
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            goToPassengerProfile(id) {
                this.$router.push(`/passengers/${id}`);
            },
            handleDrawerToggle() {
                window.getApp.$emit('APP_DRAWER_TOGGLED');
            },
            handleFullScreen() {
                Util.toggleFullScreen();
            },
            computeAiDispatchLeft() {
                const aiStatus = this.$store.state.ai_status;
                if (!aiStatus.dispatch_interval)
                    return "00:00";

                if (!eval(aiStatus.ai_stopped))
                    return "STOPPED";
                let snoozed = false;
                let when;
                if (!aiStatus.snoozed_at || moment(aiStatus.snoozed_at).add(aiStatus.snooze_interval, 'minutes') <= moment()) {
                    when = moment();
                } else {
                    when = moment(aiStatus.snoozed_at).add(aiStatus.snooze_interval, 'minutes');
                    snoozed = true;
                }
                when = when.subtract(when.seconds(), 'seconds').add(aiStatus.dispatch_interval - when.minutes() % aiStatus.dispatch_interval, 'minutes');
                const minutes = when.diff(moment(), 'minutes');
                const seconds = when.diff(moment(), 'seconds') % 60;
                return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}${snoozed ? " (Snoozed)" : ""}`;
            },
            addNewProjectSchedule() {
                this.projectScheduleDialog = true;
            }
        },
        mounted() {
            this.ai_dispatch_left = this.computeAiDispatchLeft();
        },
        intervals() {
            return [
                [() => this.ai_dispatch_left = this.computeAiDispatchLeft(), 1000]
            ];
        },
    };
</script>
